import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";
import COLORS from "../../Theme/Colors";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${COLORS.footer};
  flex-direction: column;
  color: ${COLORS.white};
  padding: 4.2rem 0;

  p {
    margin: 0;
  }
`;

export const Developer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;

  a {
    color: ${COLORS.blue};
    text-decoration: none;
  }
`;

export const Description = styled.div`
  font-size: small;
  padding: 1.5rem 2rem;
  max-width: 768px;
  color: ${COLORS.darkgray};

  ${BREAKPOINTS.MOBILE} {
    font-size: smaller;
  }
`;
